module.exports = __webpack_public_path__ + "img/disabled-checkbox.f36b776b.svg";